import React from 'react';
import PropTypes from 'prop-types';
import {
  PartnerCopy,
  PartnerCopyWrapper,
  PartnerInfo,
  PartnerInner,
  PartnerLogo,
  PartnerLogoWrapper,
  PartnerWrapper,
  VerticalLine
} from './Partner.styles';
import ApplicationSettings from '../../services/ApplicationSettings';

const Partner = ({ partner: { partnerVanityUrlName = 'notused', partnerLoanApplicationUrl } }) => {
  const cdnFastlyUrl = ApplicationSettings.getApplicationSetting('cdnFastlyUrl');
  const lowercasePartnerName = partnerVanityUrlName.toLowerCase();
  const shouldRenderPartnerCopy = () => {
    return lowercasePartnerName !== 'creditkarma';
  };

  return (
    <PartnerWrapper>
      <PartnerInner>
        <PartnerInfo>
          <PartnerLogoWrapper>
            <a href={partnerLoanApplicationUrl} rel="noopener noreferrer" target="_blank">
              <PartnerLogo
                src={`${cdnFastlyUrl}/partner-header-logos-assets/${lowercasePartnerName}.png`}
                alt={`${partnerVanityUrlName} Logo`}
              />
            </a>
          </PartnerLogoWrapper>
          {shouldRenderPartnerCopy() && (
            <PartnerCopyWrapper>
              <VerticalLine />
              <PartnerCopy>Together With</PartnerCopy>
            </PartnerCopyWrapper>
          )}
        </PartnerInfo>
      </PartnerInner>
    </PartnerWrapper>
  );
};

Partner.propTypes = {
  partner: PropTypes.shape({
    partnerVanityUrlName: PropTypes.string.isRequired,
    partnerLoanApplicationUrl: PropTypes.string.isRequired
  }).isRequired
};
// todo(oscar): START HERE: figure out if this should be pulling prop values from state instead of default values;
export default Partner;
